export interface ConditionalProps {
  condition: boolean;
  children: JSX.Element;
  fallback?: JSX.Element;
}

function Conditional(props: ConditionalProps) {
  const {condition, children, fallback = null} = props;

  if (!condition) {
    return fallback || null;
  }
  return children;
}

export default Conditional;
